(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TinperNext", [], factory);
	else if(typeof exports === 'object')
		exports["TinperNext"] = factory();
	else
		root["TinperNext"] = factory();
})(self, function() {
return 